// extracted by mini-css-extract-plugin
export var description = "Response-module--description--aea9a";
export var item = "Response-module--item--94a9a";
export var object = "Response-module--object--20957";
export var padded = "Response-module--padded--7ed3b";
export var spacer = "Response-module--spacer--10f77";
export var title = "Response-module--title--9aeb0";
export var types = "Response-module--types--dde4e";